import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { trackPageView } from '../utils/analytics';

export function usePageTracking() {
    const location = useLocation();

    useEffect(() => {
        trackPageView(location.pathname + location.search);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);
}
